module.exports = __webpack_public_path__ + "img/banner.91958999.png";